import { Theme } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
export const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    width: '100%',
    maxWidth: '100%',
    height: '100vh',
    backgroundColor: '#B7C3E9',

    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
  },
  logoContainer: {
    width: '60%',
    margin: 'auto',

    '& img': {
      filter: 'invert(1)',
      width: '100%',
      objectFit: 'fill',
    },
  },
  moduleContainer: {
    width: `calc(78% - ${theme.spacing(2)})`,
    margin: 'auto',
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(5),
  },
  formContainer: {
    width: '70%',
    margin: 'auto',
  },
}))
